import Common from './common/common.es6';
import Top from './top/top.es6';
import Service from './service/service.es6';

class Main {
    constructor() {
        this.body = document.querySelector('body');
        this.common = new Common();

        // Topのときに実行
        if (this.body.classList.contains('home')) {
            this.top = new Top();
        }

        // Serviceのときに実行
        if (this.body.classList.contains('post-type-archive-service') || this.body.classList.contains('service-template-default')) {
            this.service = new Service();
        }

        window.onload = () => {
            this.body.classList.add('-ready');
        };
    }
}

const main = new Main();
